<template>
  <div class="home">
    <el-container>
      <el-header>
        <span class="h2"> 读书郎物料展示平台</span>
        <span>读书郎教育科技有限公司</span>
        <span v-if="!auth" class="right" @click="toLogin">
          <el-button type="text">用户登录</el-button></span
        >
        <span v-if="auth" class="right" @click="outLogin"
          ><el-button type="text">退出登录</el-button></span
        >
      </el-header>
      <el-container>
        <!--        侧边菜单-->
        <el-aside width="180px">
          <el-menu
            default-active="0"
            class="el-menu-vertical-demo"
            style="overflow-x: hidden; min-height: 100%; font-size: 18px"
            @select="handleSelect"
            @open="handleOpen"
            @close="handleClose"
            background-color="#FF5722"
            text-color="#fff"
            active-text-color="#FF5722"
            :unique-opened="true"
            ref="menu"
          >
            <div style="height: 100px">
              <img
                src="../assets/readboylogo.png"
                style="
                  width: 100px;
                  height: 60px;
                  position: relative;
                  top: -30px;
                  left: -10px;
                "
              />
            </div>
            <el-menu-item index="0">
              <i class="iconfont icon-home"></i>
              <span slot="title" style="position: relative; right: 21px"
                >首页</span
              >
            </el-menu-item>
            <div v-for="(item, index) in menuItems">
              <el-submenu :index="String(item.id)">
                <template slot="title">
                  <i :class="iconItems[index]"></i>
                  <span style="position: relative; right: 5px">{{
                    item.name
                  }}</span>
                </template>
                <el-menu-item
                  :index="String(item2.id)"
                  v-for="item2 in item.children"
                >
                  <i class="iconfont icon-yuandian"></i>
                  <span slot="title" style="position: relative; left: 5px">{{
                    item2.name
                  }}</span>
                </el-menu-item>
              </el-submenu>
            </div>
          </el-menu>
        </el-aside>
        <!--        主体-->
        <el-main style="display: flex; flex-direction: column">
          <!--搜索框-->
          <el-input
            placeholder="请输入物料名称"
            prefix-icon="el-icon-search"
            @keyup.enter.native="searchByName"
            v-model="search"
            ref="searchInput"
          >
            <el-button slot="suffix" round @click="clickSearch">搜索</el-button>
          </el-input>
          <!-- 面包屑-->
          <div style="margin-top: 25px; margin-left: 5px">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item>
                <i class="iconfont icon-circle"></i>
                <span>物料</span>
              </el-breadcrumb-item>
              <el-breadcrumb-item>{{ firstMenu }}</el-breadcrumb-item>
              <el-breadcrumb-item v-if="secondMenu != ''">{{
                secondMenu
              }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <!--物料数据-->
          <div style="flex: 1 0 auto">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <el-row>
                  <el-col :span="12">
                    <span>产品</span>
                  </el-col>
                  <el-col :span="6">
                    <span style="position: relative; left: 10px">库存数量</span>
                  </el-col>
                  <el-col :span="3">
                    <span style="position: relative; left: 10px"> 价格</span>
                  </el-col>
                  <el-col :span="3">
                    <span style="position: relative; left: 10px"> </span>
                  </el-col>
                </el-row>
              </div>

              <div v-for="item in materialItems" class="item">
                <el-row class="content">
                  <el-col :span="14">
                    <div class="product">
                      <el-row>
                        <el-col :span="8" style="position: relative">
                          <el-image
                            style="width: 130px; height: 120px"
                            :src="item.thumbnail"
                            fit="contain"
                            @click="imgPreview(item.imgUrl, item.videoUrl)"
                         >
                          <div slot="error" style="width: 130px; height: 120px;display: flex; align-items: center; justify-content: center;">
                            <span>暂无图片</span>
                          </div>
                        </el-image>
                          <div
                            v-if="item.videoUrl != ''"
                            class="video-play"
                            @click="imgPreview(item.imgUrl, item.videoUrl)"
                          >
                            <i
                              size="1rem"
                              class="iconfont icon-video-player"
                            ></i>
                          </div>
                        </el-col>
                        <el-col :span="16">
                          <div class="text">
                            <div style="width: 100%" class="title">
                              <span>{{ item.name }}</span>
                            </div>
                            <div class="text-wrapper">
                              <p class="information">
                                物料编码:{{ item.number }}
                              </p>
                              <p class="information">
                                物料规格:{{ item.spec }}
                              </p>
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </el-col>

                  <el-col :span="4">
                    <div class="stock-parent">
                      <div class="stock">
                        <div class="stock-inner">
                          <!--库存数量无数据占位元素-->
                          <div
                            v-if="item.stock == ''"
                            style="width: 100%; height: 21px"
                          ></div>
                          {{ item.stock }}
                        </div>
                      </div>
                    </div>
                  </el-col>

                  <el-col :span="3">
                    <div class="price-parent">
                      <div class="price">
                        <div v-if="auth" class="price-inner">
                          {{ item.price ?  `￥${item.price}`:  `-` }}
                        </div>
                        <div v-if="!auth" class="price-inner">
                          <el-button type="text" @click="toLogin"
                            >详情请登录</el-button
                          >
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="3">
                    <div class="price-parent">
                      <div class="price">
                        <div
                          v-if="auth"
                          class="price-inner"
                          style="cursor: pointer"
                          @click="goDetail(item)"
                        >
                          查看详情
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-card>
          </div>

          <div class="pagination">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="pageSize"
              layout=" prev, pager, next, jumper"
              :total="materialTotal"
            >
            </el-pagination>
          </div>
        </el-main>
      </el-container>
    </el-container>
    <el-dialog
      title="物料详情"
      :visible.sync="dialogVisible"
      width="576px"
      center
      :close-on-click-modal="false"
    >
      <div class="material-item">
        <template v-if="Object.keys(dialogInfo).length">
          <div class="material-item__image">
            <el-image
              style="width: 100%; height: 100%"
              :src="dialogInfo.thumbnail"
              fit="cover"
              @click="imgPreview(dialogInfo.imgUrl, dialogInfo.videoUrl)"
            />
            <div
              v-if="dialogInfo.videoUrl != ''"
              class="video-play"
              @click="imgPreview(dialogInfo.imgUrl, dialogInfo.videoUrl)"
            >
              <i size="1rem" class="iconfont icon-video-player"></i>
            </div>
          </div>
          <div class="material-item__text">
            <div>物料编码: {{ dialogInfo.number }}</div>
            <div>物料名称: {{ dialogInfo.name }}</div>
            <div>物料规格: {{ dialogInfo.spec }}</div>
            <div v-if="dialogInfo.price">物料价格: ￥{{ dialogInfo.price }}</div>
            <div>物料描述: {{ dialogInfo.description }}</div>
            <div>物料库存: {{ dialogInfo.stock }}</div>
          </div>
          <div class="material-item__text">
            <div>商品状态</div>
            <div>推荐:{{ dialogInfo.is_recommend === 1 ? "是" : "否" }}</div>
            <div>最新:{{ dialogInfo.is_new === 1 ? "是" : "否" }}</div>
            <div>
              活动物料: {{ dialogInfo.used_by_activity > 0 ? "是" : "否" }}
            </div>
          </div>
        </template>
        <el-empty style="margin: 0 auto" v-else description="暂无数据" />
      </div>
    </el-dialog>

    <!--预览层-->
    <div class="previewContainer" v-show="preview">
      <div class="imgPreview" @click="clickMask">
        <div class="close-button"><i class="el-icon-close"></i></div>
        <swiper
          :options="swiperOption"
          ref="mySwiper"
          @slide-change-transition-end="changeSlide"
          class="swiper-no-swiping"
          @click.native.stop
        >
          <swiper-slide v-for="(item, index) in previewList" :key="item.url + index">
            <div 
                v-if="item.type == 'image'"
                style="height: 90vh; display: flex; justify-content: center;"
              >
                <el-image
                  ref="imageRef"
                  fit="contain" 
                  lazy-load
                  :src="item.url"
                  style="height: 90vh;"
                >
                  <template v-slot:error>暂无图片</template>
                </el-image>
            </div>
            <div  v-if="item.type == 'video'"  style="height: 90vh; display: flex; align-items: center;">
              <video-player
                class="video-player vjs-custom-skin"
                ref="videoPlayer"
                style="width: 100%"
                :playsinline="true"
                :options="playerOptions"
                id="videoPlayer"
              >
              </video-player>
            </div>
            <div style="width: 100%; height: 50px" @click="clickMask"></div>
            <div class="custom-indicator">{{ active + 1 }}/{{ previewList.length || 0 }}</div>
          </swiper-slide>

          <div class="swiper-prev" slot="button-prev">
            <i class="el-icon-arrow-left"></i>
          </div>
          <div class="swiper-next" slot="button-next">
            <i class="el-icon-arrow-right"></i>
          </div>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
import { allCategories } from "@/api";
import { getPage } from "@/api";
import { selectCategory } from "@/api";
import { search } from "@/api";
import { login } from "@/api";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import router from "@/router";

export default {
  name: "Home",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      activeIndex: "",
      search: "",
      menuItems: [],
      iconItems: [
        "iconfont icon-xiangqing",
        "iconfont icon-chenlie",
        "iconfont icon-fuzhi",
        "iconfont icon-shuqian",
        "iconfont icon-split-compare"
      ],
      //加载列表
      currentPage: 1, //当前页
      page: 0, // 分页
      pageSize: 10, // 每页条数
      materialTotal: 0, // 数据总条数
      materialItems: [],
      //预览层
      preview: false,
      active: 0,
      total: "",
      swiperOption: {
        loop: false,
        autoplay: false,
        effect: "slide",
        duration: 0,
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-next",
          prevEl: ".swiper-prev"
        }
      },
      playerOptions: {
        //播放速度
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: "auto",
        language: "zh-CN",
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: "16:9",
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [
          {
            //类型
            type: "video/mp4",
            //url地址
            src: ""
          }
        ],
        //你的封面地址
        poster: "",
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: "此物料暂无视频源",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true
        }
      },
      imgShow: false,
      videoShow: true,
      imgViewUrl: "",
      backTop: false, //置顶按钮
      //分类菜单
      openedKey: "",
      firstId: "",
      secondId: "",
      firstMenu: "首页",
      secondMenu: "",
      auth: false, //判断是否登录,
      dialogVisible: false,
      dialogInfo: {},
      previewList: []
    };
  },
  mounted() {
    this.getCategory();
    if (this.$route.params.loginStatus) {
      localStorage.setItem("loginStatus", this.$route.params.loginStatus);
    }
    if (localStorage.getItem("loginStatus") == "true") {
      this.auth = true;
    } else {
      this.auth = false;
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  created() {
    this.getAllMaterial();
  },
  methods: {
    //跳转登录页
    toLogin() {
      router.push({ path: "/login" });
    },
    //退出登录
    outLogin() {
      this.auth = false;
      localStorage.setItem("loginStatus", "false");
      this.$message.info("已退出账号");
    },
    //点击分页组件事件
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(this.currentPage);
      this.materialItems = [];
      if (this.firstId == 0 && this.search == "") {
        this.getAllMaterial();
      } else if (this.firstId != 0 && this.search == "") {
        this.getMaterialByCategory();
      }
      if (this.search != "") {
        this.searchMaterial();
      }
    },

    //请求菜单数据
    async getCategory() {
      let CategoryData = await allCategories();
      CategoryData.data.forEach((item) => {
        this.menuItems.push({
          name: item.name,
          id: item.id,
          children: item.children
        });
      });

      for (let item of this.menuItems) {
        item.children.unshift({
          id: item.id,
          name: "全部"
        });
      }
    },
    //请求所有物料数据
    async getAllMaterial() {
      let MaterialData = await getPage(this.currentPage);
      if (MaterialData.data.length === 0) {
      }
      MaterialData.data.forEach((item) => {
        this.materialItems.push({
          name: item.name,
          number: item.production_number,
          spec: item.specification,
          price: item.price,
          stock: item.stock,
          imgUrl: item.pic,
          displayUrl: item.pic?.split(",")[0],
          videoUrl: item.video,
          thumbnail: item.thumbnail,
          description: item.description,
          stock: item.stock,
          is_recommend: item.is_recommend,
          is_new: item.is_new,
          used_by_activity: item.used_by_activity,
        });
      });
      for (let item of this.materialItems) {
        item.thumbnail =
          item.displayUrl + "?x-oss-process=image/resize,w_500,m_lfit";
      }
      this.materialTotal = MaterialData.meta.pagination.total;
    },
    //按分类请求物料数据
    async getMaterialByCategory() {
      let materialData = await selectCategory(
        this.firstId,
        this.secondId,
        this.currentPage
      );
      if (materialData.data.length === 0) {
      }
      materialData.data.forEach((item) => {
        this.materialItems.push({
          name: item.name,
          number: item.production_number,
          spec: item.specification,
          price: item.price,
          stock: item.stock,
          imgUrl: item.pic,
          displayUrl: item.pic?.split(",")[0],
          videoUrl: item.video,
          thumbnail: item.thumbnail,
          description: item.description,
          stock: item.stock,
          is_recommend: item.is_recommend,
          is_new: item.is_new,
          used_by_activity: item.used_by_activity,
        });
      });
      for (let item of this.materialItems) {
        item.thumbnail =
          item.displayUrl + "?x-oss-process=image/resize,w_500,m_lfit";
      }
      this.materialTotal = materialData.meta.pagination.total;
    },
    //按名称搜索物料数据
    async searchMaterial() {
      let searchData = await search(this.search, this.currentPage);
      if (searchData.data.length === 0) {
      }
      searchData.data.forEach((item) => {
        this.materialItems.push({
          name: item.name,
          number: item.production_number,
          spec: item.specification,
          price: item.price,
          stock: item.stock,
          imgUrl: item.pic,
          displayUrl: item.pic?.split(",")[0],
          videoUrl: item.video,
          thumbnail: item.thumbnail,
          description: item.description,
          stock: item.stock,
          is_recommend: item.is_recommend,
          is_new: item.is_new,
          used_by_activity: item.used_by_activity
        });
      });
      for (let item of this.materialItems) {
        item.thumbnail =
          item.displayUrl + "?x-oss-process=image/resize,w_500,m_lfit";
      }
      this.materialTotal = searchData.meta.pagination.total;
    },
    //点击菜单事件
    handleOpen(key, keyPath) {
      this.openedKey = key;
    },
    handleClose(key, keyPath) {},
    //初始化
    categoryInit() {
      this.materialItems = [];
      this.currentPage = 1;
    },
    handleSelect(key, keyPath) {
      this.categoryInit();
      if (key === 0) {
        this.$refs.menu.close(this.openedKey);
        this.openedKey = "";
        this.firstId = 0;
        this.firstMenu = "首页";
        this.secondMenu = "";
        this.getAllMaterial();
      } else {
        for (let item of this.menuItems) {
          if (keyPath[0] == item.id) {
            this.firstMenu = item.name;
          }
          for (let item2 of item.children) {
            if (keyPath[1] == item2.id) {
              this.secondMenu = item2.name;
            }
          }
        }

        this.search = "";
        this.firstId = keyPath[0];
        if (this.secondMenu == "全部") {
          this.secondId = 0;
        } else {
          this.secondId = keyPath[1];
        }

        this.getMaterialByCategory();
      }
    },
    //搜索事件
    searchByName() {
      if (this.search != "") {
        this.categoryInit();
        this.firstMenu = "首页";
        this.secondMenu = "";
        this.$refs.menu.activeIndex = 0;
        this.$refs.menu.close(this.openedKey);
        this.searchMaterial();
      }
      this.$refs.searchInput.blur();
    },
    clickSearch() {
      if (this.search != "") {
        this.firstMenu = "首页";
        this.secondMenu = "";
        this.categoryInit();
        this.$refs.menu.activeIndex = 0;
        this.$refs.menu.close(this.openedKey);
        this.searchMaterial();
      }
    },
    //图片视频预览
    imgPreview(imgUrl, videoUrl) {
      this.preview = true; 
      this.previewList = [] 
      
      if (videoUrl) {
        this.previewList.push({
          type: "video",
          url: videoUrl,
        });
        this.playerOptions.poster =  imgUrl.split(",")[0];
        this.playerOptions.sources[0].src = videoUrl;
      }
      if (imgUrl) {
        const pics = imgUrl.split(",");
        pics.forEach((pic) => {
          this.previewList.push({
            type: "image",
            url: pic,
          });
        });
      }
    },
    //关闭预览层重置数据
    clickMask() {
      this.preview = false;
      this.imgShow = true;
      this.videoShow = false;
      this.playerOptions.sources[0].src = "";
      (this.total = ""), (this.playerOptions.poster = "");
      this.active = 0;
    },
    changeSlide() {
      let videoUrl = this.playerOptions.sources[0].src;
      this.active = this.swiper.activeIndex;
      let index = this.swiper.activeIndex;
      if (index == 0 && videoUrl != "") {
        this.imgShow = false;
        this.videoShow = true;
      } else if (index != 0 && videoUrl != "") {
        this.imgShow = true;
        this.videoShow = false;
      }
    },
    goDetail(item) {
      this.dialogVisible = !this.dialogVisible;
      this.dialogInfo = { ...item };
    }
  }
};
</script>
<style>
.el-header {
  background-color: #3e2723;
  color: white;
  height: 60px;
  line-height: 60px;
}
.h2 {
  font-size: 1.5em;
  margin: 0 25px;
}
.el-header .right {
  float: right;
  font-size: 1.1em;
}
.el-header .el-button--text {
  color: white !important;
  font-size: 1.1em;
}
.el-header .el-button--text:hover {
  color: #9a6e3a !important;
}

.el-aside {
  text-align: center;
  line-height: 200px;
}

.el-main {
  height: calc(100vh - 60px);
  background-color: #eeeeee;
  color: #333;
  text-align: center;
  padding: 20px 10px !important;
  min-height: calc(100vh - 60px);
  overflow-y: scroll !important;
}

.home > .el-container {
  width: 1100px;
  height: 100vh;
  margin: 0 auto;
}
.el-container > .el-container {
  min-height: calc(100vh - 60px);
}
/*分页插件位置*/
.pagination {
  margin-top: 20px;
  position: relative;
  bottom: 0px;
}
/*侧边菜单*/
.el-menu-item {
  font-size: 16px !important;
  border-left: solid 5px #ff5722 !important;
}

.el-menu-item.is-active {
  background-color: #fbe9e7 !important;
  color: #ff5722 !important;
  border-left: solid 5px #33a2ef !important;
}

.el-menu-item i {
  color: white !important;
}
.el-menu-item.is-active i {
  color: inherit !important;
}
.el-menu-item:hover i {
  color: #ff5722 !important;
}
/*下拉菜单*/
.el-submenu__title {
  font-size: 16px !important;
}
.el-submenu__title i {
  color: white !important;
}
.el-submenu__icon-arrow {
  top: 55% !important;
}
.el-submenu .el-menu-item {
  background-color: #fbe9e7 !important;
  color: #666 !important;
  text-align: left;
  border: none !important;
}
.el-submenu .el-menu-item:hover {
  border: none !important;
  color: #ff5722 !important;
}
.el-submenu .el-menu-item:hover i {
  color: #ff5722 !important;
}
.el-submenu .el-menu-item i {
  color: #666 !important;
}
.el-submenu .el-menu-item.is-active,
.el-submenu .el-menu-item.is-active i {
  color: #ff5722 !important;
  border: none !important;
}

.el-submenu .el-submenu__title {
  border-left: #ff5722 solid 5px;
}

.el-submenu__title:hover,
el-submenu__title:focus,
.el-menu-item:hover,
.el-menu-item:focus {
  /*  outline: 0 !important;*/
  border-left: solid 5px #33a2ef !important;
  background-color: #fbe9e7 !important;
  color: #ff5722 !important;
}
.el-submenu__title:hover.el-submenu__title i {
  color: #ff5722 !important;
}
.el-submenu.is-opened .el-submenu__title {
  border-left: solid 5px #33a2ef !important;
  background-color: #fbe9e7 !important;
  color: #ff5722 !important;
}
.el-submenu.is-opened .el-submenu__title.el-submenu__title i {
  color: #ff5722 !important;
}
/*搜索框*/
.el-input__suffix {
  right: 0px !important;
}
.el-input--suffix .el-input__inner {
  border-radius: 25px;
}
.el-input__suffix-inner > .el-button {
  width: 100px;
  color: #ff5722 !important;
  border: 1px solid #ffccbc !important;
  background-color: #ffccbc !important;
}
.el-input__suffix-inner > .el-button.is-round {
  margin-right: 3px;
  margin-top: 2px;
  padding: 10px 23px !important;
}
/*卡片*/

.el-card {
  margin-top: 15px;
  border-radius: 15px !important;
}
.el-card__header {
  padding: 25px 20px !important;
  font-size: 18px !important;
}
.el-card__body {
  padding: 0 !important;
}

.item {
  border-bottom: 1px solid #ebeef5;
}
.item:last-child {
  border-bottom: none;
}
.item:nth-child(odd) {
  background-color: #fafafa;
}
.item:hover {
  background-color: rgba(0, 0, 0, 5%);
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
.content {
  padding: 20px 10px;
}
.el-image {
  border-radius: 5px;
}
.text {
  margin-top: 5px;
  padding: 5px 10px;
}
.title {
  font-size: 20px;
  text-align: left;
}

/*文本溢出自动换行*/
.text-wrapper {
  word-break: break-all;
  word-wrap: break-word;
  font-size: 15px;
  color: #7f7f7f;
  text-align: left;
  margin-top: 10px;
}
.information {
  margin: 5px 0;
}

.stock-parent {
  width: 85px;
  height: 124px;
  display: table;
}
.stock {
  display: table-cell;
  vertical-align: middle;
}
.stock-inner {
  padding: 5px;
  border: 1px solid #e0e0e0;
  background-color: white;
  border-radius: 5px;
}
.price-parent {
  width: 100%;
  height: 124px;
  display: table;
}
.price {
  display: table-cell;
  vertical-align: middle;
}
.price-inner .el-button--text {
  font-size: 18px;
}

/*遮罩层*/

.previewContainer {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 4444;
  background-color: rgba(0, 0, 0, 0.5);
}

.custom-indicator {
  color: white;
  position: absolute;
  bottom: 10px;
  right: 47%;
  padding: 2px 5px;
  font-size: 20px;
  background: rgba(0, 0, 0, 0.5);
  width: 40px;
  text-align: center;
}
.close-button {
  color: white;
  position: absolute;
  top: 25px;
  right: 25px;
  font-size: 20px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4444;
}
.imgPreview {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.imgPreview .swiper-container {
  width: 45%;
}
.imgPreview .swiper-container .swiper-slide {
  width: 100%;
  font-size: 16px;
}

.swiper-prev,
.swiper-next {
  position: absolute;
  bottom: calc(50% + 10px);
  font-size: 20px;
  z-index: 4444;
  cursor: pointer;
  width: 40px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
}
.swiper-prev {
  left: 10px;
}
.swiper-next {
  right: 10px;
}

.swiper-prev .el-icon-arrow-left:before,
.swiper-next .el-icon-arrow-right:before {
  position: relative;
  top: 6px;
  left: 10px;
  color: #eeeeee;
}
.video-play {
  position: absolute;
  top: 45px;
  left: 36.5%;
  width: 25%;
  height: 30px;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 5px;
  border: 1px solid white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.backtop {
  position: fixed;
  bottom: 100px;
  right: 40px;
  z-index: 1;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  box-shadow: 0 0 6px rgb(0 0 0 / 12%);
  cursor: pointer;
}
.backtop:hover {
  background-color: #e3f2fd;
}
.el-icon-caret-top {
  color: #409eff !important;
}
.material-item {
  background: white;
  width: 100%;
  overflow: hidden;
  border-radius: 0 0 4px 4px;
}
.material-item__image {
  height: 200px;
  width: calc(100% - 20px);
  margin: 10px;
}
.material-item__image {
  position: relative;
  flex-shrink: 0;
}
.material-item__text {
  flex-grow: 1;
  justify-content: space-around;
  padding: 8px 8px;
  display: flex;
  flex-direction: column;
  font-size: 16px;
  word-break: break-all;
  word-wrap: break-word;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  margin: 10px;
}
.material-item__text div {
  margin-bottom: 5px;
}
</style>
